import React from 'react';
import { CheckCircle, Award, Users, Clock } from 'lucide-react';
export function WhyChooseUsSection() {
  const benefits = [{
    icon: <Users className="h-6 w-6 text-red-500" data-id="element-203" />,
    title: 'Expert Team',
    description: 'Our team consists of certified ethical hackers with years of experience in the cybersecurity industry.'
  }, {
    icon: <Award className="h-6 w-6 text-red-500" data-id="element-204" />,
    title: 'Industry Certifications',
    description: 'We hold OSCP, CEH, CISSP, and other prestigious security certifications.'
  }, {
    icon: <CheckCircle className="h-6 w-6 text-red-500" data-id="element-205" />,
    title: 'Proven Track Record',
    description: "We've helped hundreds of companies identify and remediate critical security vulnerabilities."
  }, {
    icon: <Clock className="h-6 w-6 text-red-500" data-id="element-206" />,
    title: 'Fast Turnaround',
    description: 'Get comprehensive reports quickly so you can address vulnerabilities without delay.'
  }];
  return <section id="about" className="py-20 bg-gray-800" data-id="element-207">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        <div className="lg:flex lg:items-center lg:space-x-16" data-id="element-209">
          <div className="lg:w-1/2 mb-10 lg:mb-0" data-id="element-210">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-211">
              Why Choose Our Pentesting Services
            </h2>
            <p className="text-gray-300 text-lg mb-8" data-id="element-212">
              At Pentforce, we combine technical expertise with a deep
              understanding of business needs to deliver actionable security
              insights.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-213">
              {benefits.map((benefit, index) => <div key={index} className="flex items-start" data-id="element-214">
                  <div className="flex-shrink-0 mt-1" data-id="element-215">{benefit.icon}</div>
                  <div className="ml-4" data-id="element-216">
                    <h3 className="text-lg font-medium text-white" data-id="element-217">
                      {benefit.title}
                    </h3>
                    <p className="mt-1 text-gray-400" data-id="element-218">{benefit.description}</p>
                  </div>
                </div>)}
            </div>
            <div className="mt-10" data-id="element-219">
              <button className="bg-red-600 hover:bg-red-700 text-white py-2 px-6 rounded-md font-medium transition-colors" data-id="element-220">
                Learn More About Us
              </button>
            </div>
          </div>
          <div className="lg:w-1/2 relative" data-id="element-221">
            <div className="absolute inset-0 bg-gradient-to-r from-red-500 to-red-600 rounded-xl opacity-20 blur-xl" data-id="element-222"></div>
            <div className="relative bg-gray-900 border border-gray-700 rounded-xl overflow-hidden shadow-xl" data-id="element-223">
              <div className="aspect-w-16 aspect-h-9" data-id="element-224">
                <img src="https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Cybersecurity experts working" className="object-cover w-full h-full" data-id="element-225" />
              </div>
              <div className="p-6" data-id="element-226">
                <div className="flex items-center mb-4" data-id="element-227">
                  <div className="flex -space-x-2" data-id="element-228">
                    <img className="w-10 h-10 rounded-full border-2 border-gray-900" src="https://randomuser.me/api/portraits/men/32.jpg" alt="Team member" data-id="element-229" />
                    <img className="w-10 h-10 rounded-full border-2 border-gray-900" src="https://randomuser.me/api/portraits/women/44.jpg" alt="Team member" data-id="element-230" />
                    <img className="w-10 h-10 rounded-full border-2 border-gray-900" src="https://randomuser.me/api/portraits/men/86.jpg" alt="Team member" data-id="element-231" />
                  </div>
                  <div className="ml-4" data-id="element-232">
                    <p className="text-sm font-medium text-white" data-id="element-233">
                      Our Security Experts
                    </p>
                    <p className="text-xs text-gray-400" data-id="element-234">
                      20+ Years Combined Experience
                    </p>
                  </div>
                </div>
                <div className="flex justify-between items-center" data-id="element-235">
                  <div data-id="element-236">
                    <p className="text-sm text-gray-400" data-id="element-237">Client Satisfaction</p>
                    <div className="flex items-center" data-id="element-238">
                      {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-4 h-4 text-yellow-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-239">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-240"></path>
                        </svg>)}
                      <span className="ml-2 text-white" data-id="element-241">98%</span>
                    </div>
                  </div>
                  <div data-id="element-242">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-red-900 text-red-300" data-id="element-243">
                      ISO 27001 Certified
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}